const uploadPresetOptions = {
  cloudName: "dtv3rinyx",
  uploadPreset: "Mobile360",
  language: "en",
  tags: ["appId", "templateId"],
  resourceType: "image",
};

const folderName = (appId) => {
  const folderName = appId ? `${appId}_app` : "all_apps";
  return folderName;
};

export const uploadWidget = (uploadImage, appId, options = {}) => {
  // console.log(options);
  const widget = cloudinary.openUploadWidget(
    {
      ...uploadPresetOptions,
      multiple: false,
      cropping: true,
      croppingAspectRatio: 1.78,
      croppingShowDimensions: true,
      croppingCoordinatesMode: "custom",
      croppingShowBackButton: true,
      showPoweredBy: false,
      showUploadMoreButton: true,
      maxImageFileSize: 10000000,
      styles: {
        palette: {
          window: "#FFF",
          windowBorder: "#90A0B3",
          tabIcon: "#0E2F5A",
          menuIcons: "#465362",
          textDark: "#000000",
          textLight: "#FFFFFF",
          link: "rgb(137, 210, 211)",
          action: "#FF620C",
          inactiveTabIcon: "#0E2F5A",
          error: "#F44235",
          inProgress: "#0078FF",
          complete: "#20B832",
          sourceBg: "#E4EBF1",
        },
        fonts: {
          "'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', 'Geneva', 'Verdana', 'sans-serif'":
            "https://fonts.googleapis.com/css?family=Lucida+Sans",
        },
      },
      sources: ["local", "url", "facebook", "instagram", "camera"],
      folder:
        process.env.NODE_ENV === "prod"
          ? `Mobile360/${folderName(appId)}`
          : `Mobile360/Staging/${folderName(appId)}`,
      clientAllowedFormats: ["png", "gif", "jpeg"],
      showSkipCropButton: false,
      ...options,
      text: {
        en: {
          crop: {
            crop_btn: "Crop and Save",
          },
        },
      },
    },
    function (error, result) {
      if (error) {
        return console.error(error);
      }

      let {
        info: {
          url,
          original_filename,
          original_extension,
          secure_url,
          public_id,
        },
      } = result;

      let image = {
        url,
        fileName: `${original_filename}.${original_extension}`,
        backgroundColor: null,
        description: original_filename,
        clickAction: null,
        secure_url,
        public_id,
      };

      // console.log("got image response");
      // console.dir(image);

      if (result.event === "success") {
        uploadImage(secure_url);
      }
    }
  );

  widget.open();
};

export const relocateImage = (originalImage, appId) => {
  return new Promise((resolve, reject) => {
    return fetch("https://api.cloudinary.com/v1_1/dtv3rinyx/image/upload", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        upload_preset: "Mobile360",
        file: originalImage,
        folder: `Mobile360/${folderName(appId)}`,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        resolve(res.url);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
